import { Controller } from "@hotwired/stimulus"

export default class UnreadBadgeTrackerController extends Controller<HTMLElement> {
  static values = { version: Number }

  declare versionValue: number

  private boundHandleBeforeStreamRender!: (event: Event) => void

  connect() {
    this.boundHandleBeforeStreamRender = this.handleBeforeStreamRender.bind(this)
    document.addEventListener("turbo:before-stream-render", this.boundHandleBeforeStreamRender)
  }

  disconnect() {
    document.removeEventListener("turbo:before-stream-render", this.boundHandleBeforeStreamRender)
  }

  private handleBeforeStreamRender(event: Event) {
    const customEvent = event as CustomEvent
    const { newStream } = customEvent.detail

    // Only intercept streams targeting our badge
    if (newStream.target !== "sidebar-unread-badge") {
      return
    }

    const incomingVersion = this.extractVersionFromStream(newStream)

    if (incomingVersion <= this.versionValue) {
      console.debug(
        `[unread-badge-tracker] Rejecting stale update: v${incomingVersion} <= current v${this.versionValue}`
      )
      event.preventDefault()
      return
    }

    // Accept update - track new version
    this.versionValue = incomingVersion
  }

  private extractVersionFromStream(stream: Element): number {
    const template = stream.querySelector("template")
    if (!template) return 0

    const content = template.content
    const badge = content.querySelector("#sidebar-unread-badge") as HTMLElement | null
    return parseInt(badge?.dataset.version || "0", 10)
  }
}
